export default "<app-signup></app-signup>\n"